import React, {useState, useEffect} from 'react';
import AbstractModalView from 'common/components/AbstractModalView';
import Map from './Map';
import styles from './styles.module.scss';
import PropTypes from 'prop-types';
import apiIcon from '../../assets/api-24px.svg';

const steps = {
  SELECT: 'SELECT',
  CONFIRM: 'CONFIRM'
};

const ModalApiConfirmationImage = ({buttonLabel, defaultMapPosition}) => {
  const [img, setImg] = useState(null);
  const [step, setStep] = useState(steps.SELECT);

  useEffect(() => {
    reset();

    return reset();
  }, []);

  const reset = () => {
    setStep(steps.SELECT);
    setImg(null);
  };

  const handleSelectPoint = () => {
    window.govmap.getXY().progress(
      function (response) {
        const {x, y} = response.mapPoint;
        let url = `https://ags.govmap.gov.il/staticmap/GetStaticMap?img&lg&b=0&c=${x},${y}&z=10&in=0&width=600&height=600&sbs=1&mk=1&xy=1&bb=1&bmw=44&lay=PARCEL_ALL&bs=PARCEL_ALL%7C${x},${y}&staticmap`;
        setImg(url);
        setStep(steps.CONFIRM);
      });
  };

  const handleGetImageURL = ({x, y}) => {
    const url = `https://ags.govmap.gov.il/staticmap/GetStaticMap?img&lg&b=0&c=${x},${y}&z=10&in=0&width=600&height=600&sbs=1&mk=1&xy=1&bb=1&bmw=44&lay=PARCEL_ALL&bs=PARCEL_ALL%7C${x},${y}&staticmap`;
    setImg(url);
    setStep(steps.CONFIRM);
  };

  const handleUpload = () => {

  };

  const getModalContent = () => {
    switch (step) {
      case steps.CONFIRM:
        return ({closeModal}) => (
          <>
            <div className={styles.modalContentContainer}>
              <img src={img} alt="map"/>
              <div className={styles.modalButtons}>
                <button
                  onClick={closeModal}
                  type="button"
                  className={styles.cancelButton}
                >
                  <span>ביטול</span>
                </button>
                <button
                  type="button"
                  className={styles.confirmButton}
                  onClick={handleUpload}
                >
                  <span>אשר והוסף לשומה</span>
                </button>
              </div>
            </div>
          </>
        );
      case steps.SELECT:
      default:
        return ({closeModal}) => (
          <>
            <div className={styles.modalContentContainer}>
              <Map
                className={styles.modalApiImage}
                defaultMapPosition={defaultMapPosition}
                onGetImage={handleGetImageURL}
              />
              <div className={styles.modalButtons}>
                <button
                  onClick={closeModal}
                  type="button"
                  className={styles.cancelButton}
                >
                  <span>ביטול</span>
                </button>
                <button
                  type="button"
                  className={styles.confirmButton}
                  onClick={handleSelectPoint}
                >
                  <span>אשר והוסף לשומה</span>
                </button>
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <>
      <AbstractModalView
        subPath={'api-confirmation'}
        triggerContent={({openModal}) => (
          <>
            <div className={styles.buttonViewApiConfirmation} onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              openModal();
            }}>
              <img
                src={apiIcon}
                className={styles.apiIcon}
                alt="apiIcon"
              />
              <div>{buttonLabel}</div>
            </div>
          </>
        )}
        modalContent={getModalContent()}
      />
    </>
  );
};

ModalApiConfirmationImage.propTypes = {
  buttonLabel: PropTypes.string,
  defaultMapPosition: PropTypes.object
};

export default ModalApiConfirmationImage;
